import React from "react";
import "./PhotoComponent.css";

const PhotoComponent = ({ url }) => {
  return <img className="photocomponent__img" src={url} alt="post" />;
};

export default PhotoComponent;
